const SearchParams = Object.freeze({
  EMAIL: 'email',
  NAME: 'name',
  LASTNAME: 'lastName',
  REDIRECT_URL: 'redirect-url',
} as const);

export type SearchParams = (typeof SearchParams)[keyof typeof SearchParams];
export default SearchParams;
